import type { UseDirectDealsPartnersFetchHook } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import type { Option } from '@openx/types/options';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery';

export const useDirectDealsPartnersFetch: UseDirectDealsPartnersFetchHook = ({ skip }) => {
  const { data, loading } = useOptionsByPathQuery({
    skip,
    variables: {
      path: 'deal.direct_deals_partners_options',
    },
  });

  const mapById = useMemo(() => {
    if (!data?.optionsByPath) {
      return {};
    }

    return data.optionsByPath.reduce<Record<string, Option>>((acc, optionByPath) => {
      if (optionByPath) {
        acc[optionByPath.id] = { id: optionByPath.id, name: optionByPath.name };
      }

      return acc;
    }, {});
  }, [data?.optionsByPath]);

  return {
    loading,
    mapById,
  };
};
